import {
  PAYMENTS_CHECK_STATUS_PATH,
  PAYMENTS_OUTSTANDING_CLUSTER_PATH,
  PAYMENTS_OUTSTANDING_PATH,
  PAYMENTS_PUBLIC_CHECK_STATUS_PATH,
  PAYMENTS_PUBLIC_PATH,
} from '@shared/constants/paths';
import { useSubmitPaymentRequestMutation, useSubmitPublicPaymentRequestMutation } from '@shared/services/payments';

export const getPaymentSummaryConfig = (isSharedServiceView: boolean) => ({
  public: {
    checkStatusURL: PAYMENTS_PUBLIC_CHECK_STATUS_PATH,
    navigateBackURL: PAYMENTS_PUBLIC_PATH,
    requestMutation: useSubmitPublicPaymentRequestMutation,
  },
  singpass: {
    checkStatusURL: PAYMENTS_CHECK_STATUS_PATH,
    navigateBackURL: isSharedServiceView ? PAYMENTS_OUTSTANDING_CLUSTER_PATH : PAYMENTS_OUTSTANDING_PATH,
    requestMutation: useSubmitPaymentRequestMutation,
  },
});
